import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgLocker = function SvgLocker(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M18.046 8.39V6.079c0-3.281-2.671-6-6-6-3.328 0-6 2.672-6 6v2.313c-1.828 1.64-3 4.03-3 6.656C3.046 20.016 7.078 24 12 24c4.922 0 8.954-4.031 8.954-8.953a8.719 8.719 0 00-2.907-6.656zm-5.015 9.657a.99.99 0 01-.985.984c-.515 0-.984-.468-.984-.984v-6a.99.99 0 01.984-.985c.516 0 .985.47.985.985v6zm3-11.016a8.753 8.753 0 00-3.985-.937 8.753 8.753 0 00-3.984.937v-.953a3.981 3.981 0 013.984-3.984 3.981 3.981 0 013.985 3.984v.953z"
  }));
};

export default SvgLocker;